import React, { useEffect, useState } from "react";
import WorkItem from "./WorkItem";
import { portfolioNav, projectsData } from "./portfolioData";

const Works = () => {
  const [item, setItem] = useState({ name: "All" });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (item.name === "All") {
      setProjects(projectsData);
    } else {
      const newProjects = projectsData.filter(
        (project) => project.category === item.name
      );
      setProjects(newProjects);
    }
  }, [item.name]);

  const handleClick = (e, idx) => {
    setItem({ name: e.target.textContent });
    setActive(idx);
  };

  return (
    <div>
      <div className="work__filters">
        {portfolioNav.map((item, idx) => {
          return (
            <span
              className={`${
                active === idx ? "work__item-active" : ""
              } work__item`}
              onClick={(e) => {
                handleClick(e, idx);
              }}
              key={idx}
            >
              {item.name}
            </span>
          );
        })}
      </div>
      <div className="work__container vertical-scroll snaps-inline container grid">
        {projects.map((item, idx) => {
          return <WorkItem item={item} key={idx} />;
        })}
      </div>
    </div>
  );
};

export default Works;
